import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import PasswordField from "../Configuracao/PasswordField";

const FIELDS = [
  { name: "clientId", label: "ClientId" },
  { name: "clientSecret", label: "ClientSecret" },
  { name: "chaveAES", label: "ChaveAES" },
];

const CredentialK8PayForm = ({ credentialK8Pay, setCredentialK8Pay, handleSave, isSaving = false }) => {
  const handleOnChange = (event) => {
    const { name, value } = event.target;
    setCredentialK8Pay((prevState) => ({ ...prevState, [name]: value }));
  };

  return (
    <Stack spacing={2}>
      {FIELDS.map(({ name, label }) => (
        <PasswordField
          key={name}
          label={label}
          name={name}
          value={credentialK8Pay?.[name] ?? ""}
          onChange={handleOnChange}
        />
      ))}
      <Box>
        <Button variant="contained" onClick={handleSave} disabled={isSaving}>
          Salvar
        </Button>
      </Box>
    </Stack>
  );
};

export default CredentialK8PayForm;
